
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck, faCheckDouble, faCircleCheck, faClock, faPaperPlane, faTriangleExclamation
} from '@fortawesome/free-solid-svg-icons';

import Loading from 'component/Loading';
import NoData from 'component/NoData';

const EInvoiceAuditTableRow = ({ record, status }) =>
{
  const getIcon = () => {
    switch(status)
    {
      case 'pending':   return <FontAwesomeIcon icon={faClock} />;
      case 'accepted':  return <FontAwesomeIcon icon={faPaperPlane} />;
      case 'sent':      return <FontAwesomeIcon icon={faCheck} />;
      case 'delivered': return <FontAwesomeIcon icon={faCheckDouble} />;
      case 'read':      return <FontAwesomeIcon icon={faCircleCheck} />;
      case 'failed':    return <FontAwesomeIcon icon={faTriangleExclamation} />;
    }
    return null;
  }

  return (
    <tr key={``}>
      <td className={`col-eiar-status ${status}`}>
      { getIcon(status) }
      </td>
      <td className="col-eiar-company">{ record.company }</td>
      <td className="col-eiar-license">{ record.cd_license }</td>
      <td className="col-eiar-media-type">{ record.media_type }</td>
      <td className="col-eiar-destination">{ record.destination }</td>
      <td className="col-eiar-error">{ record.error }</td>
    </tr>
  );
}

export const EInvoicingAuditTable = ({
  batch, filter
}) =>
{

  const getFilteredItems = () =>
  {
    return ['failed', 'pending', 'accepted', 'sent', 'delivered', 'read'].reduce((output, status) =>
      [...output, ...filter(batch[status]||[]).map(x =>
        <EInvoiceAuditTableRow key={`${batch.batch_id}-${x.cd_license}-${x.destination}`} record={x} status={status} />
      )]
    , []);
  }

  // skip if not ready
  if (!batch) {
    return <Loading />
  }

  // get filtered count
  const filteredItems = getFilteredItems();
  if (filteredItems.length <= 0) {
    return <NoData />
  }

  // render
  return (
    <table className="einvoicing-audit-table data-table">
      <colgroup>
        <col id="col-eiar-status"/>
        <col id="col-eiar-company"/>
        <col id="col-eiar-license"/>
        <col id="col-eiar-media-type"/>
        <col id="col-eiar-destination"/>
        <col id="col-eiar-error"/>
      </colgroup>
      <thead>
        <tr>
          <th className="col-eiar-status">狀態</th>
          <th className="col-eiar-company">公司</th>
          <th className="col-eiar-license">車牌</th>
          <th className="col-eiar-media-type">媒體類型</th>
          <th className="col-eiar-destination">寄送地址</th>
          <th className="col-eiar-error">錯誤訊息</th>
        </tr>
      </thead>
      <tbody>
        { filteredItems }
      </tbody>
    </table>
  );
}

export default EInvoicingAuditTable;

